import React from 'react';
export function TimelineSection() {
  const phases = [{
    id: '01',
    title: 'Supply Aggregation',
    description: "We aggregate supply from manufacturers across the world: we know what's available where and at what price."
  }, {
    id: '02',
    title: 'Demand Analysis',
    description: 'We analyze data from online retail and marketplaces to build a model of market demand for each product, in each region and channel.'
  }, {
    id: '03',
    title: 'Transaction Handling',
    description: 'We surface under-supplied goods for each channel and region; then we manage the transaction between supplier and retailer from purchase to delivery.'
  }];
  return <section id="use-cases" className="bg-[#1a1a1a] text-[#fafafa] py-32 md:py-40 px-4" data-id="element-133">
      <div className="max-w-7xl mx-auto" data-id="element-134">
        <div className="mb-24 md:mb-32" data-id="element-135">
          <p className="text-lg font-bold uppercase tracking-widest text-[#b8d4e8] mb-4" data-id="element-136">
            How It Works
          </p>
          <h2 className="text-4xl md:text-6xl font-light leading-tight max-w-4xl" data-id="element-137">
            Pimlico Trading is building the{' '}
            <span className="font-semibold text-[#b8d4e8]" data-id="element-138">data layer</span>{' '}
            between manufacturers and online retailers, so that stock moves
            efficiently from factory to consumer.
          </h2>
        </div>

        <div className="space-y-20 md:space-y-32 relative" data-id="element-139">
          {/* Center Vertical Line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-gradient-to-b from-[#b8d4e8]/40 via-[#b8d4e8]/20 to-transparent" data-id="element-140" />

          {phases.map((phase, index) => {
          const isEven = index % 2 === 0;
          return <div key={phase.id} className={`relative flex items-center ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-141">
                {/* Content - takes up half width on desktop */}
                <div className={`w-full md:w-1/2 ${isEven ? 'md:pr-16' : 'md:pl-16'}`} data-id="element-142">
                  <div className={`${isEven ? 'md:text-right' : 'md:text-left'}`} data-id="element-143">
                    <p className="text-lg font-mono text-[#b8d4e8] mb-3 tracking-widest" data-id="element-144">
                      PHASE {phase.id}
                    </p>
                    <h3 className="text-3xl md:text-4xl font-semibold mb-5 text-white leading-tight" data-id="element-145">
                      {phase.title}
                    </h3>
                    <p className="text-gray-400 text-lg leading-relaxed" data-id="element-146">
                      {phase.description}
                    </p>
                  </div>
                </div>

                {/* Center Dot Indicator */}
                <div className="hidden md:flex absolute left-1/2 top-0 -translate-x-1/2 w-10 h-10 bg-[#b8d4e8] rounded-full items-center justify-center z-10 shadow-lg shadow-[#b8d4e8]/20" data-id="element-147">
                  <span className="text-sm font-bold text-[#1a1a1a]" data-id="element-148">
                    {phase.id}
                  </span>
                </div>

                {/* Empty space on the other side */}
                <div className="hidden md:block w-1/2" data-id="element-149" />

                {/* Mobile: Left-aligned with dot */}
                <div className="md:hidden absolute left-0 top-1 w-8 h-8 bg-[#b8d4e8] rounded-full flex items-center justify-center z-10 shadow-lg shadow-[#b8d4e8]/20" data-id="element-150">
                  <span className="text-xs font-bold text-[#1a1a1a]" data-id="element-151">
                    {phase.id}
                  </span>
                </div>
                <div className="md:hidden absolute left-4 top-0 bottom-0 w-px bg-gradient-to-b from-[#b8d4e8]/40 via-[#b8d4e8]/20 to-transparent" data-id="element-152" />
                <div className="md:hidden pl-14 w-full" data-id="element-153">
                  <p className="text-xs font-mono text-[#b8d4e8] mb-3 tracking-widest" data-id="element-154">
                    PHASE {phase.id}
                  </p>
                  <h3 className="text-3xl font-semibold mb-5 text-white leading-tight" data-id="element-155">
                    {phase.title}
                  </h3>
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-156">
                    {phase.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}